import React from "react";

import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";

import BreadCrumbs from "components/ui/BreadCrumbs";
import { createBreadcrumb } from "features/files/utils/breadcrumpUtil";

import FilesTab from "./FilesTab";
import { useNavigate, useSearchParams } from "react-router-dom";

const Files = ({ noBreadCrumbs = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "files";

  return (
    <>
      <Helmet>
        <title>{"File Library"}</title>
      </Helmet>
      {!noBreadCrumbs && <BreadCrumbs breadcrumbs={createBreadcrumb()} />}
      <div className="d-flex flex-row mb-3 align-items-center">
        <div className="flex-grow-1">
          <h1 className="mb-0">File Library</h1>
        </div>
      </div>

      <Row>
        <Col xs={12} className="mb-3">
          <Card>
            <Tabs
              activeKey={tab}
              onSelect={(k) => navigate(`?tab=${k}`)}
              variant="tabs"
              className="m-3"
            >
              <Tab eventKey={"files"} title="Files & Photos" className="px-2">
                <FilesTab />
              </Tab>
            </Tabs>
          </Card>
        </Col>
      </Row>
    </>
  );
};

Files.propTypes = {
  noBreadCrumbs: PropTypes.bool,
};

export default Files;
